
import { PictureBe } from './shared/image-model';

export class ImageCommon {

    public static setPictureLabels(item: PictureBe[]): string{
        let that = this;
        let pictureLabels = "";
        item.forEach(function(pic){
            pictureLabels += pictureLabels.length == 0 
                ? pic.Label
                : '|' + pic.Label;
        });
        if (pictureLabels.startsWith('|')){
            pictureLabels = pictureLabels.substring(1);
        }
        return this.removeDuplicateLabels(pictureLabels.split('|'));
    }
    
    static removeDuplicateLabels(labels:string[]): string{
        let temp: string[] = labels.filter(function (item, index, tempTest) {
            return tempTest.indexOf(item) == index;
        });

        let filteredLables = "";
        temp.forEach(x=>filteredLables += '|' + x )
        return filteredLables.startsWith('|')
            ? filteredLables.substring(1)
            : filteredLables;
    }

    public static SetBase64Image(pics:PictureBe[]){
        for (var i = 0; i < pics.length; i++) {
            let image1:any = 'data:image/png;base64,' + pics[i].PictureImage;
            pics[i].PictureImage = image1;
        }
    }

  
    

    public static RemovePic(pics:PictureBe[], imageIdToDelete: number) {
        let inx = pics.findIndex(x=>x.Id == imageIdToDelete);
        if (inx != -1)
            pics.splice(inx,1);

        // if (imageId == this.instruction.Pictures[0].Id && this.instruction.Pictures.length == 1) {
        //     this.instruction.Pictures.pop();
        //     this.pictureIdS.splice(0, 1);
        // }
        // else {
        //     let tmpArr: PictureBe[] = [];
        //     for (var i = 0; i < this.instruction.Pictures.length; i++) {
        //         if (imageId != this.instruction.Pictures[i].Id) {
        //             tmpArr.push(this.instruction.Pictures[i]);
        //         } 
        //         else {
        //             this.pictureIdS.splice(i, 1);
        //         }
        //     }
        //     this.instruction.Pictures = tmpArr;
        // }
    }
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/image-library/image-common.ts